import BaseMode from './BaseMode'

/**
 * Режим «Оформление» — создание полиса с нуля.
 */
export default class CreateMode extends BaseMode {
    static code  = 'create'
    static title = 'Оформление'
    static calcTitle = 'Расчитать'
    static checkoutTitle = 'Оформить'

    /** POST: расчёт премии ОГПО (V2 / KBS) */
    static calculateUrl = '/api/v2/calculate/ogpo/calculate-premium'
    /** POST: запуск оформления договора BPM */
    static checkoutUrl = '/api/v2/contract/bpm/checkout'
}
